<template>
  <BaseWidget
    :class="['accountant-customers', widget.type]"
    :loading="loading"
    @refresh-data="refreshData"
    @set-config="setConfig"
    v-on="$listeners"
  >
    <template v-slot:header>
      <div class="title">
        <span class="title-icon"> </span>
        {{ title }}
      </div>
      <div class="description">{{ subtitle }}</div>
    </template>
    <template v-slot:content>
      <div class="data-wrap">
        <div class="data-item connected">{{ connectedCompanies }} <span>{{ $gettext('Connected') }}</span></div>
        <div class="data-item disconnected">{{ disconnectedCompanies }} <span>{{ $gettext('Disconnected') }}</span></div>
        <div class="data-item pending">{{ pendingInvites }} <span>{{ $gettext('Pending invites') }}</span></div>
      </div>
    </template>
    <template v-slot:actions>
       <GekkoButton 
          @click="$router.push({ name: 'Customers' })"
          :text="$gettext(' See my customers')" 
          variant="link"
          class="text-blue p-0"
          size="sm"
        />
    </template>
  </BaseWidget>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseWidget from '@/components/dashboard/widgets/BaseWidget'
import GekkoButton from '@/components/GekkoButton';

import AccountantsService from '@/store/services/accountants.service'

export default {
  name: 'accountant-customers-widget',
  components: {
    BaseWidget,
    GekkoButton
   },
  props: {
    widget: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: true,
      title: '',
      subtitle: '',
      config: { status: '' },
      filters: {},
      connectedCompanies: 0,
      disconnectedCompanies: 0,
      pendingInvites: 0
    }
  },
  computed: {
    ...mapGetters({
      getCompanyId: 'main/getCompanyId',
    })
  },
  mounted() {
    this.setupWidget()
    this.setObjectStatus(this.widget.config)
  },
  methods: {
    setConfig(config) {
      if (config.status) this.setObjectStatus(config)
      this.$emit('save-config', this.config)
    },
    setupWidget() {
      this.title = this.$gettext('Customers')
      this.subtitle = this.$gettext('Customer connection summary')
      this.getData()
    },
    setObjectStatus (config) {
      if (config.status) {
        this.config.status = (config.status && config.status !== 'all') ? config.status : ''
      } 
      this.setFilters()
    },
    setFilters (status = false) {
      this.filters.status = (status) ? (status === 'all') ? '' : status : this.config.status
      this.refreshData()
    },
    refreshData () {
      this.getData()
    },
    updateFilters (status) {
      this.filters.status = (status === 'all') ? '' : status
      this.setFilters(status)
    },
    getData() {
      this.loading = true
      AccountantsService.getAccountantTotals(this.filters).then((response) => {
        console.log(response)
        this.connectedCompanies = response.data.number_of_connected_companies
        this.disconnectedCompanies = response.data.number_of_disconnected_companies
        this.pendingInvites = response.data.number_of_pending_invites
        this.loading = false
      })
    },
  },
}
</script>

<style lang="scss">
.accountant-customers {
  .data-wrap {
    display: flex;
    gap: 2rem;
    font-family: $fontMedium;
    width: 100%;
    height: 100%;
    justify-content: space-evenly;
    .data-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 40px;
      line-height: 1.3;
      span {
        font-family: $fontRegular;
        font-size: 14px;
        color: $colorTextSemi;
        white-space: nowrap;
      }
      &.connected { color: $colorBrand; }
      &.disconnected { color: $colorDanger; }
      &.pending { color: $colorWarning; }
    }
  }
}
</style>
